import { useState } from "react";

import TeamMemberForm from "../../../../team/components/TeamMemberForm/TeamMemberForm";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";

import OfferForm from "../../OfferForm/OfferForm";

import useInquiryOfferDropdownMenuOptions from "../hooks/useInquiryOfferDropdownMenuOptions";

export default function InquiryOfferDropdownMenu({ offer, production }) {
	const [offerFormType, setOfferFormType] = useState(null);
	const [openTeamMemberForm, setOpenTeamMemberForm] = useState(false);

	const options = useInquiryOfferDropdownMenuOptions({
		setOfferFormType,
		setOpenTeamMemberForm,
		production,
		offer,
	});

	return (
		<>
			<DropdownMenu options={options} />

			{offerFormType && (
				<OfferForm
					type={offerFormType}
					offer={offer}
					production={production}
					onClose={() => setOfferFormType(null)}
				/>
			)}

			{openTeamMemberForm && (
				<TeamMemberForm
					offer={{ ...offer, agreement: { id: "external" } }}
					production={production}
					onClose={() => setOpenTeamMemberForm(false)}
				/>
			)}
		</>
	);
}
